import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Box from "../Box";
import Title from "../Title";
import EventInfo from "./EventInfo";
import EventStatusBar from "./EventStatusBar";
import PlayerAvailability from "./PlayerAvailability";
import StatusDreamTeam from "./StatusDreamTeam";
import TransfersPanel from "./TransfersPanel";

const StatusWrapper = styled.div`
  max-width: 1220px;
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding-inline-end: ${({ theme }) => theme.space[2]};
    padding-inline-start: ${({ theme }) => theme.space[2]};
  }
`;

const StatusCols = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    display: flex;
    justify-content: space-between;
  }
`;

const StatusMain = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    flex: 0 0 66.66%;
  }
`;

const StatusSecondary = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    flex: 0 0 30%;
  }
`;

const StyledTitle = styled(Title)`
  margin: ${({ theme }) => theme.space[2]} 0;
`;

const LoggedInStatus = styled.div`
  display: flex;
  justify-content: center;
  margin: ${({ theme }) => theme.space[3]} 0;
  padding: ${({ theme }) => `${theme.space[2]} ${theme.space[6]} 1.2rem`};
  border-radius: ${({ theme }) => theme.radii[1]};
  background-color: ${({ theme }) => theme.colors.secondary};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[5]};
  font-weight: normal;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
`;

const Status: React.FC = () => {
  const now = useSelector(getCurrentEvent);
  const player = useSelector(getPlayerData);
  const { t } = useTranslation();

  if (!now || !player) {
    return null;
  }

  return (
    <StatusWrapper>
      <LoggedInStatus>
        {t(
          "status.loggedIn",
          "Welcome to the Liga Portugal Betclic Fantasy {{ first_name }} {{ last_name }}",
          {
            first_name: `${player.first_name}`,
            last_name: ` ${player.last_name}`,
          },
        )}
      </LoggedInStatus>
      <StyledTitle>
        {t("status.title", " {{ name }} Status ", {
          name: now.name,
        })}
      </StyledTitle>
      <Box mb={4}>
        <EventStatusBar />
      </Box>
      <Box mb={4}>
        <EventInfo />
      </Box>
      <Box mb={4}>
        <StatusDreamTeam />
      </Box>
      <StatusCols>
        <StatusMain>
          <Box mb={4}>
            <TransfersPanel />
          </Box>
          <Box mb={4}>
            <TransfersPanel isOut={true} />
          </Box>
        </StatusMain>
        <StatusSecondary>
          <Box mb={4}>
            <PlayerAvailability />
          </Box>
        </StatusSecondary>
      </StatusCols>
    </StatusWrapper>
  );
};

export default Status;
